module.exports = __webpack_public_path__ + "static/media/Room.c6c47933.png";